// @flow
export const MODAL_THEME_API = {
  overlay: '',
  modal: ''
};
